import autobind from 'autobind-decorator';
import * as React from 'react';
import { useTranslation, withTranslation, WithTranslation } from 'react-i18next';
import { Col, Form, Row, Spin } from 'antd';
import { connect } from 'redux-scaffolding-ts';
import { RouteComponentProps, withRouter } from 'react-router-dom';
import * as projecttaskassignmentsStore from 'src/stores/projecttaskassignments-store';

import * as dataStore from 'src/core/stores/dataStore';
import { GridTableView, SpaceMap } from 'src/components/collections/grid-table';
import HttpService from 'src/core/services/http.service';
import { ProjectStore } from 'src/stores/projects-store';
import * as projecttasksStore from 'src/stores/projecttasks-store';
import { ProjectMemberItemsStore, ProjectMemberSummary } from 'src/stores/projectmembers-store';
import { resolve } from 'src/inversify.config';
import { CacheProps, withCache } from 'src/core/services/cache.service';
import { IdentityProps, withIdentity } from 'src/core/services/authentication';
import { CommandResult } from 'src/core/stores/types';
import ContentTitle from 'src/core/ui/content-header';
import { TaskTemplatesStore, TaskTemplateSummary } from 'src/stores/templates-store';
import { clone } from 'src/core/utils/object';
import { notify } from 'src/core/ui/floatingNotification';
import { NewProjectTaskAssignmentItem, NewProjectTaskAssignmentStore, ProjectTemplateTaskAssignmentSummary } from 'src/stores/projecttaskassignments-store';
import { NewProjectTasksFromTemplates, ProjectTaskSummary } from 'src/stores/projecttasks-store';
import { useEffect, useState } from 'react';
import { UserProfileProps, withUserProfile } from 'src/components/user-profile';
import { DataModel, QueryResult } from 'src/core/stores/dataStore';
import { DeleteObject, GridTableMultipleView, SaveObject } from 'src/components/collections/grid-table-multiple';

interface ProjectTaskAssignmentsViewProps extends RouteComponentProps<{ companyId: string, projectId: string }>, WithTranslation, CacheProps, IdentityProps {
    projectName: string | undefined;
    refresh: boolean;
    //onRefresh: () => void;
    companyAllowCir: boolean,
    companyAllowCii: boolean,
}

interface ProjectTaskAssignmentsViewState {
    query: dataStore.Query;
    projectTaskQuery: dataStore.Query;
    gridAssignmentsData: projecttaskassignmentsStore.ProjectTaskAssignmentSummary[];
    newProjectTaskAssignmentShown: boolean;
    isGridViewActive: boolean;
    taskTemplatesQuery: dataStore.Query;
}

const _taskTemplatesStore = new TaskTemplatesStore();
const _newTaskFromTemplatesStore = new NewProjectTasksFromTemplates();
const _projectTasksStore = new projecttasksStore.ProjectTasksStore();
const _projectItemTasksStore = new projecttasksStore.ProjectTaskItemsStore();
const _newProjectTaskAssignmentStore = new NewProjectTaskAssignmentStore();
const _projectAssingmentsStore = new projecttaskassignmentsStore.ProjectTaskAssignmentsStore();

const ProjectTaskTemplateAssignmentsDashboard = (props: ProjectTaskAssignmentsViewProps) => {

    const [projects, setProjects] = useState<QueryResult<ProjectTaskSummary>>()
    const [projectSpaceMap, setProjectSpaceMap] = useState<any>()
    const [tasks, setTasks] = useState<QueryResult<TaskTemplateSummary>>()
    const [taskTemplateSpaceMap, setTaskTemplateSpaceMap] = useState<any>()
    const [assingmentsSpaceMap, setAssingmentsSpaceMap] = useState<any>()
    const [assignments, setAssignments] = useState<ProjectTemplateTaskAssignmentSummary[]>()
    const [isLoading, setIsLoading] = useState<boolean>()
    const [isError, setIsError] = useState<boolean>()
    const [msgError, setMsgError] = useState<string>()
    const [projectTaskQuery, setProjectTaskQuery] = useState<any>({ searchQuery: '', orderBy: [{ field: 'title', direction: 'Ascending', useProfile: true }], skip: 0, take: 10 })
    const [taskTemplatesQuery, setTaskTemplatesQuery] = useState<any>({ searchQuery: '', orderBy: [{ field: 'title', direction: 'Ascending', useProfile: true }], skip: 0, take: 10 })
    const companyId = props.match.params.companyId;
    const { t, i18n } = useTranslation();


    useEffect(() => {
        loadGridData()
    }, [companyId]);

    useEffect(() => {
        buid()
    }, [tasks, projects, assignments]);

    const loadGridData = async () => {
        //get project members
        setIsLoading(true)
        _taskTemplatesStore.changeUrl(companyId)
        const tasks = await _taskTemplatesStore.getTaskTemplates(taskTemplatesQuery);
        setTasks(tasks)
        //get project tasks
        _projectItemTasksStore.changeUrlByProjectEmployee(companyId);
        const projects = await _projectItemTasksStore.getProjectTask(projectTaskQuery)

        const newProjects = {...projects, items: projects.items.filter(f => f.approved || f.approved == undefined)}
        setProjects(newProjects)

        loadGridAssignmentsData()
        setIsLoading(false)
    }

    const onCreateNewTasks = async (items: SaveObject[]) => {
        try {
            await _newTaskFromTemplatesStore.changeUrlMasiveSave(companyId);
            await _newTaskFromTemplatesStore.postMasiveSave(items).then((result : any) => {
                if ((result.data as any).success) {
                    loadGridData();
                } else {
                    throw new Error("La solicitud falló");
                }
            });
        } catch (error) {
            console.error(error);
        }
    }

    const softDeleteMasiveTask = async (tasksToDelete: DeleteObject[]) => {
        await _projectTasksStore.changeUrlMasiveDelete(companyId);
        await _projectTasksStore.deleteMasive(tasksToDelete);
        loadGridAssignmentsData()
    }

    const loadGridAssignmentsData = async () => {
        await _projectTasksStore.changeUrlLoadGridAssignmentsData(companyId);
        _projectTasksStore.getAllAssignments().then((data : any) => {
            setAssignments(data.items)
        })
    }

    const buid = () => {
        const projectsSpaceMap = {
            model: {
                query: projectTaskQuery,
                data: projects as unknown as DataModel<ProjectTaskSummary>,
                onQueryChanged: (query) => {
                    _projectItemTasksStore.changeUrlByProjectEmployee(companyId);
                    setIsLoading(true)
                    _projectItemTasksStore.getProjectTask(query).then(async (result) => {
                        setProjectTaskQuery(query)
                        const newProjects = {...result, items: result.items.filter(f => f.approved || f.approved == undefined)}
                        setProjects(newProjects)
                        setIsLoading(false)
                    })
                }
            },
            width: 250,
            itemKey: "id",
            itemText: "title",
            key: "projects",
            title: t("Projects"),
            ellipsis: true
        } as SpaceMap<ProjectTaskSummary>

        setProjectSpaceMap(projectsSpaceMap)

        const taskTemplateSpaceMap = {
            model: {
                query: taskTemplatesQuery,
                data: tasks as unknown as DataModel<TaskTemplateSummary>,
                onQueryChanged: (query) => {
                    _taskTemplatesStore.changeUrl(companyId);
                    _taskTemplatesStore.getTaskTemplates(query).then(async (result) => {
                        setTaskTemplatesQuery(query)
                        setTasks(result)
                    })
                }
            },
            width: 50,
            height: 200,
            showSideways: true,
            itemKey: "id",
            itemText: "title",
            key: "tasks",
            title: t("Taskssss"),
            ellipsis: true
        } as SpaceMap<TaskTemplateSummary>

        setTaskTemplateSpaceMap(taskTemplateSpaceMap)

        var assingmentsSpaceMap = {
            model: {
                query: { searchQuery: '', orderBy: [{ field: 'employeeTitle', direction: 'Ascending', useProfile: true }], skip: 0, take: 10 },
                data: assignments ?? [],
                onQueryChanged: () => { }
            },
            alternativeDataSource: assignments,
            itemKey: "id",
            itemText: "title",
            key: "assingments",
            title: "assingments"
        } as unknown as SpaceMap<projecttaskassignmentsStore.ProjectTemplateTaskAssignmentSummary>


        setAssingmentsSpaceMap(assingmentsSpaceMap)
    }

    return (
        <Spin size='large' spinning={isLoading}>
            <Row>
                <Col span={10}>
                    <ContentTitle title={t('Projects')} />
                </Col>

            </Row>
            {tasks && projects && assignments && taskTemplateSpaceMap && projectSpaceMap && assingmentsSpaceMap &&
             <div style={{ padding: 20, marginBottom: 50 }}>
                <GridTableMultipleView<ProjectMemberSummary, TaskTemplateSummary, ProjectTemplateTaskAssignmentSummary>
                    onRefresh={loadGridData}
                    onSaveMultipleItem={onCreateNewTasks}
                    onDeleteMultipleItem={softDeleteMasiveTask}
                    xData={taskTemplateSpaceMap}
                    yData={projectSpaceMap}
                    cellData={assingmentsSpaceMap}
                    xDataIndexZ="taskIds"
                    yDataIndexZ="projectIds"
                    scroll={{ x: 1500 }}
                    isMultiple={true}
                />
            </div>}
        </Spin>
    )
}

export default (withUserProfile(withIdentity(withRouter(withTranslation()(Form.create({})(ProjectTaskTemplateAssignmentsDashboard) as any) as any)) as any) as any) as React.ComponentClass<ProjectTaskAssignmentsViewProps>;
